import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-79" data-mp="3uei2ph2cts2v">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-80" data-mp="c8c1na07knfo">
        <h2 className="font-serif text-5xl leading-tight sm:text-6xl" data-id="element-81" data-mp="84ntoq7nzptw">
          You Are the Practitioner
          <br data-id="element-82" data-mp="m4f5qlemew59" />
          <span className="text-amber" data-id="element-83" data-mp="m3wyktqf6xik">Your Practice Has Been Waiting For.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-84" data-mp="h6n8dbv7ihto">
          The scattered searching stops today. The incomplete references end here. The professional
          practice you have been building — it finally has its foundation.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate" data-id="element-85" data-mp="14uwru74y6thn">
          675+ pages of structured Tarot resources · 6 complete volumes · 5 bonus guides · Visual
          correspondence charts ·
          Therapeutic question libraries · Printable resources · Ethical guidelines · Protection
          protocols · Integration systems · Everything you need to build the therapeutic tarot
          practice you were always meant to have.
        </p>
        <div className="mt-10" data-id="element-86" data-mp="2m571qa9eflx3">
          <Countdown dark={false} data-id="element-87" data-mp="2r2gotj9bflhr" />
        </div>
        <div className="mt-10" data-id="element-88" data-mp="2r38lkxenfp9m">
          <CTAButton size="large" data-id="element-89" data-mp="2v3iryb6cshp0">🚀 GET INSTANT ACCESS — $27 USD</CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-90" data-mp="2v1obb9247bqq">
          🔒 Secure Payment · ⚡ Instant Access · 🛡️ 7-day guarantee · 💳 Card · PayPal · ♾️ Lifetime
          Access
        </p>
      </Reveal>
    </section>;
}